const tracking = {
  readTrackingAcademiaAlumnos: 'tracking/academia/{{uuid_academia}}/alumnos',
  readTrackingAcademiaAlumnosExportar: 'tracking/academia/{{uuid_academia}}/alumnos/exportar',
  readTrackingProyectoProgreso: 'tracking/proyecto/{{uuid_proyecto}}/progreso',
  readTrackingUsuarioLogins: 'tracking/usuario/{{uuid_usuario}}/logins',
  readTrackingUsuarioResumen: 'tracking/usuario/{{uuid_usuario}}/resumen'
}

export default tracking
